var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.835,
    height: 19.826,
    viewBox: "0 0 18.835 19.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar_add_on_FILL0_wght400_GRAD0_opsz48",
    d: "M134.374-863.148h-2.23a.717.717,0,0,1-.53-.215.726.726,0,0,1-.214-.533.711.711,0,0,1,.214-.528.725.725,0,0,1,.53-.211h2.23v-2.23a.717.717,0,0,1,.215-.53.726.726,0,0,1,.533-.214.712.712,0,0,1,.529.214.725.725,0,0,1,.211.53v2.23h2.23a.717.717,0,0,1,.53.215.726.726,0,0,1,.214.533.711.711,0,0,1-.214.528.725.725,0,0,1-.53.211h-2.23v2.23a.717.717,0,0,1-.215.53.726.726,0,0,1-.533.214.711.711,0,0,1-.528-.214.725.725,0,0,1-.211-.53Zm-12.887.991a1.426,1.426,0,0,1-1.041-.446,1.426,1.426,0,0,1-.446-1.041v-13.383a1.427,1.427,0,0,1,.446-1.041,1.426,1.426,0,0,1,1.041-.446H123.1v-.694a.767.767,0,0,1,.228-.565.767.767,0,0,1,.565-.228.8.8,0,0,1,.583.228.756.756,0,0,1,.235.565v.694h6.443v-.694a.768.768,0,0,1,.228-.565.768.768,0,0,1,.565-.228.8.8,0,0,1,.583.228.756.756,0,0,1,.235.565v.694h1.611a1.426,1.426,0,0,1,1.041.446,1.427,1.427,0,0,1,.446,1.041v7.484a5.633,5.633,0,0,0-.743-.049,5.634,5.634,0,0,0-.743.049v-2.776H121.487v8.674h7.93a3.78,3.78,0,0,0,.074.743,6.174,6.174,0,0,0,.2.743Zm0-11.648h12.887v-3.222H121.487Zm0,0v0Z",
    transform: "translate(-120 880)",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/IconCalendar.bd4b5d9d.svg";
export { ForwardRef as ReactComponent };